import { render, staticRenderFns } from "./pricelist.vue?vue&type=template&id=e783857c&"
import script from "./pricelist.vue?vue&type=script&lang=js&"
export * from "./pricelist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e783857c')) {
      api.createRecord('e783857c', component.options)
    } else {
      api.reload('e783857c', component.options)
    }
    module.hot.accept("./pricelist.vue?vue&type=template&id=e783857c&", function () {
      api.rerender('e783857c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2W6Tle6s5Zzth/JS/comp/pricelist.vue"
export default component.exports